import { isUndefined } from "lodash";
import { RoundingMethod } from "../../../../../../../redux/constants/OrdersPage/order";

import type { Order } from "../../../../../../../services";
import type { ColorState } from "../../../../../../../redux/reducers/settings/colors";

const cellProcessing = (
	item: Order.Model,
	colors?: ColorState,
): cellProcessing.Retval => {
	const rounding = item.cost?.settings?.rounding ?? {};

	const {
		multiple = { value: 0, active: false },
		method = RoundingMethod.GENERAL,
		precision = 2,
	} = rounding;

	const priceValue = item.cost?.value ?? 0;
	const currency = item.cost?.currency?.settings?.name ?? "";

	const getRoundedPriceNumber = (): number => {
		if (isUndefined(priceValue)) return 0;

		let processed = priceValue;

		if (multiple.active && multiple.value !== 0) {
			processed /= multiple.value;
		} else {
			processed *= 10 ** precision;
		}

		switch (method) {
			case RoundingMethod.CEIL:
				processed = Math.ceil(processed);
				break;
			case RoundingMethod.FLOOR:
				processed = Math.floor(processed);
				break;
			default:
				processed = Math.round(processed);
		}

		if (multiple.active && multiple.value !== 0) {
			processed *= multiple.value;
		} else {
			processed /= 10 ** precision;
		}

		return Number(processed.toFixed(precision));
	};

	const price = getRoundedPriceNumber();

	return {
		content: `${price} ${currency}`,
		backgroundColor: colors?.[item.paymentType] || "#ffffff",
		price,
		currency,
	};
};

declare namespace cellProcessing {
	interface Retval {
		content: string;
		backgroundColor: string;
		price: number;
		currency: string;
	}
}

export default cellProcessing;
